import React from "react";
import TableHeading from "../../components/ui/TableHeading";
import { processDisbursementHeadings } from "../../utils/ui_data";
import { numberWithCommas } from "../../utils/customFunction";
import CardColComponent from "../genericCardComponent/CardColComponent";

function DividendTable({
  dividendData,
  activeTab,
  report = false,
  columns = "",
}: {
  dividendData?: any;
  activeTab?: any;
  report?: boolean;
  columns?: any;
}) {
  return (
    <div className="table-responsive">
      <table
        style={{ color: report ? "black" : "" }}
        className={report ? "report" : "table"}
      >
        <TableHeading
          headings={
            report
              ? processDisbursementHeadings?.filter((ele) =>
                  columns?.includes(ele?.label),
                )
              : processDisbursementHeadings
          }
        />

        <tbody>
          {dividendData.length !== 0 ? (
            <>
              {dividendData.map((data, index) => (
                <tr key={data._id} className="text-nowrap">
                  {((columns?.includes("Sr") && report) || !report) && (
                    <td id={report ? "test" : ""}>{index + 1}</td>
                  )}
                  {report ? null : <td>{data.folio_no}</td>}
                  {report ? null : <td>{data.unitholder_name}</td>}
                  {((columns?.includes("Holding") && report) || !report) && (
                    <td id={report ? "test" : ""} align="right">
                      <CardColComponent
                        subTitle={numberWithCommas(
                          parseFloat(
                            data?.unitholder_holding_for_dividend || 0,
                          )?.toFixed(4),
                        )}
                        units={true}
                        simple={true}
                      />
                    </td>
                  )}
                  {((columns?.includes("Gross Dividend") && report) ||
                    !report) && (
                    <td id={report ? "test" : ""} className="text-right">
                      <CardColComponent
                        subTitle={numberWithCommas(
                          parseFloat(data?.gross_dividend || 0)?.toFixed(2),
                        )}
                        amount={true}
                        simple={true}
                      />
                    </td>
                  )}
                  {((columns?.includes("ROC Rate") && report) || !report) && (
                    <td id={report ? "test" : ""} className="text-right">
                      <CardColComponent
                        subTitle={numberWithCommas(
                          parseFloat(data?.refund_purchase_nav || 0)?.toFixed(
                            4,
                          ),
                        )}
                        amount={true}
                        simple={true}
                      />
                    </td>
                  )}
                  {((columns?.includes("ROC Amount") && report) || !report) && (
                    <td id={report ? "test" : ""} className="text-right">
                      <CardColComponent
                        subTitle={numberWithCommas(
                          parseFloat(data?.refund_of_capital || 0)?.toFixed(2),
                        )}
                        amount={true}
                        simple={true}
                      />
                    </td>
                  )}
                  {((columns?.includes("ROC Units") && report) || !report) && (
                    <td id={report ? "test" : ""} className="text-right">
                      <CardColComponent
                        subTitle={
                          data.refund_of_capital > 0
                            ? numberWithCommas(
                                parseFloat(
                                  data?.reinvestment_units || 0,
                                )?.toFixed(4),
                              )
                            : numberWithCommas(
                                parseFloat(
                                  data?.refund_of_capital_units || 0,
                                )?.toFixed(4),
                              )
                        }
                        units={true}
                        simple={true}
                      />
                    </td>
                  )}
                  {((columns?.includes("Taxable Dividend") && report) ||
                    !report) && (
                    <td id={report ? "test" : ""} className="text-right">
                      <CardColComponent
                        subTitle={numberWithCommas(
                          parseFloat(data.taxable_dividend || 0)?.toFixed(2),
                        )}
                        amount={true}
                        simple={true}
                      />
                    </td>
                  )}
                  {report ? null : (
                    <td className="text-right">
                      <CardColComponent
                        subTitle={numberWithCommas(
                          parseFloat(data?.tax_rate || 0)?.toFixed(2),
                        )}
                        amount={true}
                        simple={true}
                        percentage={true}
                      />
                    </td>
                  )}
                  {((columns?.includes("Tax Amount") && report) || !report) && (
                    <td id={report ? "test" : ""} className="text-right">
                      <CardColComponent
                        subTitle={numberWithCommas(
                          parseFloat(data?.tax_amount || 0)?.toFixed(2),
                        )}
                        amount={true}
                        simple={true}
                      />
                    </td>
                  )}
                  {((columns?.includes("Net Dividend") && report) ||
                    !report) && (
                    <td id={report ? "test" : ""} className="text-right">
                      <CardColComponent
                        subTitle={numberWithCommas(
                          parseFloat(data?.net_dividend || 0)?.toFixed(2),
                        )}
                        amount={true}
                        simple={true}
                      />
                    </td>
                  )}
                  {((columns?.includes("Encash") && report) || !report) && (
                    <td id={report ? "test" : ""} className="text-right">
                      <CardColComponent
                        subTitle={numberWithCommas(
                          parseFloat(data?.encashment_amount || 0)?.toFixed(2),
                        )}
                        amount={true}
                        simple={true}
                      />
                    </td>
                  )}
                  {report ? null : (
                    <td className="text-right">
                      {data?.reinvest ? "YES" : "NO"}
                    </td>
                  )}
                  {((columns?.includes("Reinv Units") && report) ||
                    !report) && (
                    <td id={report ? "test" : ""} className="text-right">
                      <CardColComponent
                        subTitle={
                          data?.refund_of_capital > 0
                            ? numberWithCommas(
                                parseFloat(
                                  data?.reinvestment_units || 0,
                                )?.toFixed(4),
                              )
                            : numberWithCommas(
                                parseFloat(
                                  data?.reinvestment_units || 0,
                                )?.toFixed(4),
                              )
                        }
                        units={true}
                        simple={true}
                      />
                    </td>
                  )}
                </tr>
              ))}
            </>
          ) : activeTab ? (
            <tr>
              <td
                colSpan={processDisbursementHeadings?.length}
                className="text-center text-nowrap"
              >
                {" "}
                No data found with {activeTab}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
}

export default DividendTable;
